const decoratePropsByDefaultValues = (props) => {
    const { mode = "default" /* HeaderMode.DEFAULT */, enableTheme = false, fixedBackground = false, showContentWidget = true, ...rest } = props;
    return {
        enableTheme,
        fixedBackground,
        showContentWidget,
        mode,
        ...rest,
    };
};
const splitProps = (props) => {
    const { serviceURL, regions, getServiceUrl, formatPath, currentRegion, mode, domains, user, enableTheme, fixedBackground, oidcHandlerPrefix, settings, promo, search, onOpen, onClose, onMenuOpen, onMenuClose, ...rest } = props;
    return [
        {
            serviceURL,
            regions,
            getServiceUrl,
            formatPath,
            currentRegion,
            mode,
            domains,
            user,
            enableTheme,
            fixedBackground,
            oidcHandlerPrefix,
            settings,
            promo,
            search,
            onOpen,
            onClose,
            onMenuOpen,
            onMenuClose,
        },
        rest,
    ];
};

export { decoratePropsByDefaultValues, splitProps };
//# sourceMappingURL=props.js.map
